export default {
  'Enter a promo code! First limit people receive amount coins':
    'Bir promosyon kodu gir! İnsanlara verilen coin miktarının ilk limiti',
};
